/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Checkout_Cancelled_ToastInputs */

const en_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout was cancelled`)
};

const fr_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le paiement a ete annule`)
};

const de_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bestellvorgang wurde abgebrochen.`)
};

const it_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il checkout è stato annullato`)
};

const ru_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оформление заказа было отменено.`)
};

const es_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pago fue cancelado`)
};

const zh_cn2_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退房已取消`)
};

const ja_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックアウトはキャンセルされました`)
};

const hi_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चेकआउट रद्द कर दिया गया`)
};

const pt_pt2_signup_checkout_cancelled_toast = /** @type {(inputs: Signup_Checkout_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O pedido foi cancelado.`)
};

/**
* | output |
* | --- |
* | "Checkout was cancelled" |
*
* @param {Signup_Checkout_Cancelled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_checkout_cancelled_toast = /** @type {((inputs?: Signup_Checkout_Cancelled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Checkout_Cancelled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_checkout_cancelled_toast(inputs)
	if (locale === "de") return de_signup_checkout_cancelled_toast(inputs)
	if (locale === "it") return it_signup_checkout_cancelled_toast(inputs)
	if (locale === "ru") return ru_signup_checkout_cancelled_toast(inputs)
	if (locale === "es") return es_signup_checkout_cancelled_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_checkout_cancelled_toast(inputs)
	if (locale === "ja") return ja_signup_checkout_cancelled_toast(inputs)
	if (locale === "hi") return hi_signup_checkout_cancelled_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_checkout_cancelled_toast(inputs)
	return en_signup_checkout_cancelled_toast(inputs)
});